import { AssignmentTurnedIn as ActionIcon } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReplyActionsDialog from "./ReplyActionsDialog";

const ReplyActionButton = ({
  reply,
  ticketId,
  count = 0,
  onSaved,
  size = "small",
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        size={size}
        variant="outlined"
        startIcon={<ActionIcon />}
        onClick={() => setOpen(true)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          gap: 1,
        }}
      >
        {t("replyActions.button")}
        {count > 0 && (
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 22,
              height: 22,
              px: 0.75,
              borderRadius: "11px",
              bgcolor: "primary.main",
              color: "primary.contrastText",
              fontSize: "0.75rem",
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {count}
          </Box>
        )}
      </Button>
      <ReplyActionsDialog
        open={open}
        onClose={() => setOpen(false)}
        reply={reply}
        ticketId={ticketId}
        onSaved={onSaved}
      />
    </>
  );
};

export default ReplyActionButton;
